<template>
  <div>
    <q-btn color="primary" label="Back to list" icon="chevron_left" @click="$emit('back')" />

    <div class="q-mt-md">
      <div class="row q-col-gutter-md">
        <div class="col-12 col-sm-6">
          <p><strong>Booking ID: </strong>{{ booking.id | formatId }}</p>
          <p><strong>Invoice ID: </strong>{{ booking.invoice.id | formatId }}</p>
          <p class="q-mb-none">
            <strong>Invoice Status: </strong>
            <span v-if="booking.invoice.paid" class="text-weight-medium text-positive"> PAID </span>
            <span v-else class="text-weight-medium text-muted">UNPAID</span>
          </p>
        </div>

        <div class="col-12 col-sm-6">
          <p>
            <strong>Customer: </strong>
            <span class="text-capitalize">
              {{ booking.request.shipper.businessName }}
            </span>
          </p>

          <p class="q-mb-none">
            <strong>Status: </strong>
            <span class="text-weight-medium" :class="getStatusClass(booking.status)">
              {{ booking.status }}
            </span>
          </p>
        </div>

        <div class="col-12">
          <PDFPreview is-invoice :request-from-client="booking.request" :response-from-client="booking" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PDFPreview from '@/components/PDFPreview.vue';
import { getStatusClass } from '@/utils';

export default {
  components: {
    PDFPreview,
  },
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getStatusClass,
  },
};
</script>
